var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(_vm.$t("BusinessStockDistributionRatioAddSku.title")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-position": "top",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddSku.supportWarehouseType"
                        ),
                        prop: "supportWarehouseType",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "constant-key": "STOCK_WAREHOUSE_TYPE_SON_4_LIST",
                        },
                        on: { change: _vm.onChangeSupportWarehouseType },
                        model: {
                          value: _vm.form.supportWarehouseType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseType", $$v)
                          },
                          expression: "form.supportWarehouseType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddSku.supportWarehouseId"
                        ),
                        prop: "supportWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: { "type-code": _vm.supportTypeCodeList },
                        on: { change: _vm.onChangeSupportWarehouseId },
                        model: {
                          value: _vm.form.supportWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseId", $$v)
                          },
                          expression: "form.supportWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddSku.receiveWarehouseType"
                        ),
                        prop: "receiveWarehouseType",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          disabled: "",
                          value: _vm.form.receiveWarehouseTypeName,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddSku.receiveWarehouseId"
                        ),
                        prop: "receiveWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.receiveWarehouseList },
                        on: { change: _vm.onChangeReceiveWarehouseId },
                        model: {
                          value: _vm.form.receiveWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiveWarehouseId", $$v)
                          },
                          expression: "form.receiveWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.spuCode"),
                        prop: "spuCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.spuCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "spuCode", $$v)
                          },
                          expression: "form.spuCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.spuName"),
                        prop: "spuName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.spuName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "spuName", $$v)
                          },
                          expression: "form.spuName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddSku.categoryId"
                        ),
                        prop: "categoryId",
                      },
                    },
                    [
                      _c("BjGoodsTypeTreeSelect", {
                        attrs: {
                          placeholder: _vm.$t("chooseText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "categoryId", $$v)
                          },
                          expression: "form.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionRatioAddSku.skuCode"
                        ),
                        prop: "skuCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.skuCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "skuCode", $$v)
                          },
                          expression: "form.skuCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-align-end" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "cyan", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.onSearch()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("queryText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: {
                    click: function ($event) {
                      return _vm.onReset()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("resetText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "BusinessStockDistributionRatioAddSku.supplyWarehouseList"
                      )
                    ) +
                    " "
                ),
                _c("span", { staticClass: "tips" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionRatioAddSku.warehouseType"
                        )
                      ) +
                      ":" +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionRatioAddSku.realPosition"
                        )
                      ) +
                      "；" +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionRatioAddSku.warehouseCode"
                        )
                      ) +
                      ":" +
                      _vm._s(_vm.form.supportWarehouseCode) +
                      "；" +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionRatioAddSku.warehouseName"
                        )
                      ) +
                      ":" +
                      _vm._s(_vm.form.supportWarehouseName) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "vxe-table",
                {
                  ref: "tableSupport",
                  attrs: {
                    data: _vm.tableDataSupport,
                    stripe: "",
                    border: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                    "row-config": { keyField: "skuCode" },
                    height: "400px",
                    "empty-text": _vm.$t("table.emptyText"),
                    "checkbox-config": { checkMethod: _vm.selectableSupport },
                  },
                  on: {
                    scroll: _vm.tableSupportScroll,
                    "checkbox-all": _vm.handleSelectSupportAllEvent,
                    "checkbox-change": _vm.handleSelectionChangeSupport,
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "checkbox", align: "center", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "60",
                      align: "center",
                      label: _vm.$t("table.countText"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionRatioAddSku.table.categoryName"
                      ),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionRatioAddSku.table.skuCode"
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-col", { staticClass: "flex-box-center", attrs: { span: 2 } }, [
            _c(
              "div",
              {
                staticClass: "button-arrow",
                on: { click: _vm.onSupport2ReceiveFn },
              },
              [
                _c("i", { staticClass: "el-icon-arrow-right" }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessStockDistributionRatioAddSku.distribute")
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "button-arrow",
                on: { click: _vm.onReceive2SupportFn },
              },
              [
                _c("i", { staticClass: "el-icon-arrow-left" }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessStockDistributionRatioAddSku.withdraw")
                    )
                  ),
                ]),
              ]
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c(
                "p",
                { staticClass: "title" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionRatioAddSku.receivingWarehouseList"
                        )
                      ) +
                      " "
                  ),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionRatioAddSku.warehouseType"
                          )
                        ) +
                        ":" +
                        _vm._s(_vm.form.receiveWarehouseTypeName) +
                        "；" +
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionRatioAddSku.warehouseCode"
                          )
                        ) +
                        ":" +
                        _vm._s(_vm.form.receiveWarehouseCode) +
                        "；" +
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionRatioAddSku.warehouseName"
                          )
                        ) +
                        ":" +
                        _vm._s(_vm.form.receiveWarehouseName) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSet } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionRatioAddSku.warehouseStructureRatio"
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vxe-table",
                {
                  ref: "tableReceive",
                  attrs: {
                    data: _vm.tableDataReceive,
                    stripe: "",
                    border: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                    "row-config": { keyField: "skuCode" },
                    height: "400px",
                    "empty-text": _vm.$t("table.emptyText"),
                  },
                  on: {
                    scroll: _vm.tableReceiveScroll,
                    "checkbox-all": _vm.handleSelectReceiveAllEvent,
                    "checkbox-change": _vm.handleSelectionChangeReceive,
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "checkbox", align: "center", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "60",
                      align: "center",
                      label: _vm.$t("table.countText"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionRatioAddSku.table.categoryName"
                      ),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionRatioAddSku.table.skuCode"
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }